$(->
  handle_question_error = (jqXHR,textStatus,errorThrown)->
    errors = eval('(' + jqXHR.responseText + ')')
    for attr, e of errors
      id = '#question_' + attr + '_input'
      $(id + ' p.inline-errors').remove()
      $(id).addClass('error').append('<p class="inline-errors">' + e[0])


  create_question = (the_modal, f, done)->
    $.ajax({
      url: f.attr('action')
      type: "POST"
      dataType: 'json'
      data: f.serialize()
      cache: false
      success: (data)->
        if $('#quick_update').length > 0
          $('#quick_update').val('1')
          $('#quick_update').closest('form').submit()
        if the_modal.data('after-create')
          the_modal.data('after-create')(data)
        done()
      error: handle_question_error
    })

  get_question_form = (modal)->
    f = modal.find('form')
    f.find('textarea.tinymce').each ->
      tinymce.get($(this).attr('id')).save()
    return f

  $(document).on 'click', '.modal.question_new .modal-footer .add-another', (ev)->
    the_modal = $(this).closest('.modal')
    f = the_modal.find('form')
    create_question the_modal, f, ->
      f[0].reset()
    return false

  $(document).on 'click', '.modal.question_new .modal-footer .done', (ev)->
    the_modal = $(this).closest('.modal')
    f = get_question_form(the_modal)
    if f.find('#question_name').val() == ''
      the_modal.modal('hide')
      return false
    create_question the_modal, f, ->
      $('.modal.in').modal('hide')
    return false

  $(document).on 'click', '.modal.question_edit .modal-footer .done', (ev)->
    the_modal = $(this).closest('.modal')
    f = get_question_form(the_modal)
    $.ajax({
      url: f.attr('action'),
      type: "PATCH",
      dataType: 'json',
      data: f.serialize(),
      cache: false,
      success: (data)->
        if the_modal.data('after-update')
          the_modal.data('after-update')(data)
        $('.modal.in').modal('hide')
      error: handle_question_error
    })
    return false

  $(document).on 'click', '.question_defaults a', (ev)->
    ev.preventDefault()
    to_copy = $(this).closest('.question_defaults').data('copy').split(',')
    $.ajax({
      url: "/manage/questions/" + $(this).data('id')
      type: "GET"
      dataType: 'json'
      cache: false
      success: (data)->
        for prop in to_copy
          $('#question_' + prop).val(data[prop])
    })
    false

  $(document).on 'click', 'a.get_question_defaults', (ev)->
    ev.preventDefault()
    $('.question_defaults').html('')
    d = $('.question_defaults').data('source')
    $.ajax(
      url: "/manage/questions/?is_goal=" + d.is_goal + "&question_set_id=" + d.question_set_id
      type: "GET"
      dataType: 'json'
      cache: false
      success: (data)->
        i = 0
        for item in data
          line_class = 'odd'
          if i % 2 == 0
            line_class = 'even'
          item_name = item.name
          if item.hint?
            item_name = item.hint
          $('.question_defaults').append('<a href="#" class="' + line_class + '" data-id="' + item.id + '">' + item_name + '</a>')
          i++
    )
    false

  $(document).on 'change', '.modal form.question #question_question_type', (ev)->
    type_id = $(this).val()
    $('#answers .form-control').prop('disabled', true)
    if $('#answers .collapse.in').length > 0
      if $('#answers .collapse.in').attr('id').replace('answer_type_','') != type_id
        $('#answers .collapse.in').collapse('hide')
        setTimeout ->
          $('#answers #answer_type_' + type_id).collapse('show')
          $('#answers #answer_type_' + type_id + ' .form-control').prop('disabled', false)
        , 200
      else
        $('#answers .collapse.in .form-control').prop('disabled', false)
    if $('#question_name').val() == '' && $('#question_name').data('defaults')?
      $('#question_name').val($('#question_name').data('defaults')[type_id])

    # If a question changes after populating `question_prefill` and the option
    # selected is no longer available, it will not be removed from params.
    # Checking for the option and conditionally applying the value on change
    # prevents that issue
    preloaded = $('#question_prefill').data('loadedOption')
    if $('#question_prefill option[value="' + preloaded + '"]')[0] != undefined
      $('#question_prefill').val(preloaded)
    else
      $('#question_prefill').val('')

  $(document).on 'reset', '.modal form.question', (ev)->
    the_qtype = $(this).find('#question_question_type')
    setTimeout ->
      the_qtype.trigger('change')
    , 10

  $(document).on 'show.bs.modal', '.modal.question', (e)->
    the_qtype = $(this).find('#question_question_type')
    setTimeout ->
      the_qtype.trigger('change')
    , 10

)
